import React, { Component } from 'react';
import { Table, Input, Button, Icon, Modal } from 'antd';
import { List, Card } from 'antd';
import { Row, Col, Divider } from 'antd';
import { Steps } from 'antd';
import { Checkbox } from 'antd';
import { EditorFormatListNumbered } from 'material-ui';
import 'antd/dist/antd.css';
// import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import { ContextMenu, Item, Separator, Submenu, ContextMenuProvider } from 'react-contexify';
import 'react-contexify/dist/ReactContexify.min.css';
import openSocket from 'socket.io-client';
const cnfmModal = Modal.confirm;
const Step = Steps.Step;
const Search = Input.Search;
const id_enable_FindBest = "id_enable_FindBest";
const id_disable_FindBest = "id_disable_FindBest";
const parser = new DOMParser();
let thisContext = null;

let aState = {
    filterDropdownVisible: false,
    trips: [],
    searchTxt: '',
    filtered: false,
    columnData: [],
    needUpdateComponent: false,
    selectedRowKeys: []
};


class RtdTripsTable extends Component {
    constructor() {
        super();
        this.state = aState;
        this.onTxtSearch = this.onTxtSearch.bind(this);
        this.onCheckBoxChange = this.onCheckBoxChange.bind(this);
        this.onClickFindBest = this.onClickFindBest.bind(this);
        this.onClickRefreshTrips = this.onClickRefreshTrips.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        let aRowSelectors = document.getElementsByClassName("ant-table-selection-column");
        for (var i = 0; i < aRowSelectors.length; i++) {
            aRowSelectors[i].style.minWidth = "8px";
            aRowSelectors[i].style.width = "16px";
            aRowSelectors[i].style.padding = "6px";
        }
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.trips === this.state.trips) {
            return;
        }
        // if (typeof nextProps.trips !== "undefined" && nextProps.trips !== null && nextProps.trips.length !== 0) {
        this.setState({ trips: nextProps.trips });
        // }
        this.initColumnData(nextProps.trips);
    }

    /* componentDidMount(){
        // first set minWidth, then set width
        let aRowSelectors = document.getElementsByClassName("ant-table-selection-column");
        for(var i = 0; i < aRowSelectors.length; i++){
            aRowSelectors[i].style.minWidth = "20px";
            aRowSelectors[i].style.width = "20px";
        }
    } */

    componentDidMount() {
        let aRowSelectors = document.getElementsByClassName("ant-table-selection-column");
        for (var i = 0; i < aRowSelectors.length; i++) {
            aRowSelectors[i].style.minWidth = "8px";
            aRowSelectors[i].style.width = "16px";
            aRowSelectors[i].style.padding = "6px";
        }
    }

    componentDidUpdate() {
        let aRowSelectors = document.getElementsByClassName("ant-table-selection-column");
        for (var i = 0; i < aRowSelectors.length; i++) {
            aRowSelectors[i].style.minWidth = "8px";
            aRowSelectors[i].style.width = "16px";
            aRowSelectors[i].style.padding = "6px";
        }
    }

    onTxtSearch(theTxt) {
        console.log(theTxt);
        if ((theTxt != null && theTxt.toLowerCase() === this.state.searchTxt.toLowerCase()) || ((theTxt == null || theTxt.length === 0) && this.state.searchTxt.length === 0)) {
            return;
        } else {
            this.state.searchTxt = theTxt;
            this.setState({ searchTxt: theTxt });
            this.initColumnData(this.state.trips);
            /* if (theTxt == null || theTxt.length == 0) {
                this.initColumnData(this.state.trips);
            } else {
                if(this.state.trips!==null && this.state.trips.length!==0){
                    this.state.searchTxt = theTxt;
                    this.setState({searchTxt: theTxt});
                    this.initColumnData(this.state.trips);
                }
            } */
        }
    }

    onCheckBoxChange(e) {
        console.log(`checked = ${e.target.checked}`);
        let aNewTrips = this.state.trips;
        let aNewColumnData = this.state.columnData;
        let aBodyStyle = { padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
        for (var i = 0; i < this.state.trips.length; i++) {
            if (e.target.checked) {
                aNewTrips[i].selected = true;
                this.state.trips[i].selected = true;
                aBodyStyle = { padding: 8, backgroundColor: "lightblue", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
            } else {
                aNewTrips[i].selected = false;
                this.state.trips[i].selected = false;
                aBodyStyle = { padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
            }
            aNewColumnData[i].trip_info = <Card style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={aBodyStyle}
                bordered={false} type="inner" >
                <Row type="flex" justify="space-between" align="middle">
                    <Col>
                        <font size="2"><b>{aNewTrips[i].client_name.toUpperCase()}</b></font><font size="2" style={{ marginLeft: 6 }}>({aNewTrips[i].trip_direction.toUpperCase()})</font>
                    </Col>
                    <Col>
                        <font size="2">{aNewTrips[i].trip_type.toUpperCase()}</font>
                    </Col>
                </Row>
                <Row type="flex" justify="start" align="middle">
                    <Col>
                        <font size="1"><b>{this.convertMinutesToAmPm(aNewTrips[i].pu_time)}</b></font>
                    </Col>
                    <Col style={{ marginLeft: 8 }}>
                        <font size="1"><b>{aNewTrips[i].pu_addr.toUpperCase()}</b></font>
                    </Col>
                </Row>
                <Row type="flex" justify="start" align="middle">
                    <Col style={{ marginLeft: 40 }}>
                        <Icon type="arrow-down" />
                    </Col>
                    <Col style={{ marginLeft: 6 }}>
                        <font size="2">{aNewTrips[i].segment_id.toUpperCase()}</font>
                    </Col>
                    <Col style={{ marginLeft: 8 }}>
                        <font size="1"><b>{aNewTrips[i].oper_id.toUpperCase()}</b></font>
                    </Col>
                    <Col style={{ marginLeft: 8 }}>
                        <font size="2" style={{ color: "green" }}><b>{aNewTrips[i].status.toUpperCase()}</b></font>
                    </Col>
                </Row>
                <Row type="flex" justify="start" align="middle">
                    <Col>
                        <font size="1"><b>{this.convertMinutesToAmPm(aNewTrips[i].do_time)}</b></font>
                    </Col>
                    <Col style={{ marginLeft: 8 }}>
                        <font size="1"><b>{aNewTrips[i].do_addr.toUpperCase()}</b></font>
                    </Col>
                </Row>
            </Card>
            this.state.columnData[i].trip_info = aNewColumnData[i].trip_info;
        }
        this.state.needUpdateComponent = true;
        this.setState({
            trips: aNewTrips,
            columnData: aNewColumnData,
            needUpdateComponent: true
        });
        // this.setState({ columnData: aNewColumnData });
        this.props.updateTripsSelection(aNewTrips);
    }

    initColumnData(theTrips) {
        let aColumnData = [];
        if (typeof theTrips !== "undefined" && theTrips !== null && theTrips.length !== 0) {
            let aBodyStyle = { padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
            outterloop: for (var i = 0; i < theTrips.length; i++) {
                if (this.state.searchTxt !== null && this.state.searchTxt.length !== 0) {
                    /* let aSearchArray = this.state.searchTxt.split(/(\s+)/).filter(function (e) { return e.trim().length > 0; });
                    for (var j = 0; j < aSearchArray.length; j++) {
                        if (theTrips[i].client_name.toLowerCase().indexOf(aSearchArray[j].toLocaleLowerCase()) < 0 && theTrips[i].pu_addr.toLowerCase().indexOf(aSearchArray[j].toLocaleLowerCase()) < 0 &&
                            theTrips[i].do_addr.toLowerCase().indexOf(aSearchArray[j].toLocaleLowerCase()) < 0 && theTrips[i].segment_id.toLowerCase().indexOf(aSearchArray[j].toLocaleLowerCase()) < 0 &&
                            theTrips[i].trip_type.toLowerCase().indexOf(aSearchArray[j].toLocaleLowerCase()) < 0 && theTrips[i].status.toLowerCase().indexOf(aSearchArray[j].toLocaleLowerCase()) < 0) {
                            continue outterloop;
                        }
                    } */
                    if (theTrips[i].client_name.toLowerCase().indexOf(this.state.searchTxt.toLowerCase()) < 0 && theTrips[i].pu_addr.toLowerCase().indexOf(this.state.searchTxt.toLowerCase()) < 0 &&
                        theTrips[i].do_addr.toLowerCase().indexOf(this.state.searchTxt.toLowerCase()) < 0 && theTrips[i].segment_id.toLowerCase().indexOf(this.state.searchTxt.toLowerCase()) < 0 && 
                        theTrips[i].trip_type.toLowerCase().indexOf(this.state.searchTxt.toLowerCase()) < 0 && theTrips[i].status.toLowerCase().indexOf(this.state.searchTxt.toLowerCase()) < 0 ) {
                        continue;
                    }
                }
                if (false && theTrips[i].selected) {
                    aBodyStyle = { padding: 8, backgroundColor: "lightblue", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
                } else {
                    aBodyStyle = { padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
                }
                let aId = id_enable_FindBest;
                if (false && (typeof theTrips[i].segment_id) !== "undefined" && theTrips[i].segment_id !== null && theTrips[i].segment_id.length !== 0) {
                    aId = id_disable_FindBest;
                }
                aColumnData.push({
                    key: (i + 1).toString(),
                    idx_in_trips: (i + 1).toString(),
                    trip_info: <ContextMenuProvider id={aId}>
                        <Card className={(i + 1).toString()} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={aBodyStyle}
                            bordered={false} type="inner" >
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <font size="2"><b>{theTrips[i].client_name.toUpperCase()}</b></font><font size="2" style={{ marginLeft: 6 }}>({theTrips[i].trip_direction.toUpperCase()})</font>
                                </Col>
                                <Col>
                                    <font size="2">{theTrips[i].trip_type.toUpperCase()}</font>
                                </Col>
                            </Row>
                            <Row type="flex" justify="start" align="middle">
                                <Col>
                                    <font size="1"><b>{this.convertMinutesToAmPm(theTrips[i].pu_time)}</b></font>
                                </Col>
                                <Col style={{ marginLeft: 8 }}>
                                    <font size="1"><b>{theTrips[i].pu_addr.toUpperCase()}</b></font>
                                </Col>
                            </Row>
                            <Row type="flex" justify="start" align="middle">
                                <Col style={{ marginLeft: 40 }}>
                                    <Icon type="arrow-down" />
                                </Col>
                                <Col style={{ marginLeft: 6 }}>
                                    <font size="2">{theTrips[i].segment_id.toUpperCase()}</font>
                                </Col>
                                <Col style={{ marginLeft: 8 }}>
                                    <font size="1"><b>{theTrips[i].oper_id.toUpperCase()}</b></font>
                                </Col>
                                <Col style={{ marginLeft: 8 }}>
                                    <font size="2" style={{ color: "green" }}><b>{theTrips[i].status.toUpperCase()}</b></font>
                                </Col>
                            </Row>
                            <Row type="flex" justify="start" align="middle">
                                <Col>
                                    <font size="1"><b>{this.convertMinutesToAmPm(theTrips[i].do_time)}</b></font>
                                </Col>
                                <Col style={{ marginLeft: 8 }}>
                                    <font size="1"><b>{theTrips[i].do_addr.toUpperCase()}</b></font>
                                </Col>
                            </Row>
                        </Card>
                    </ContextMenuProvider>
                });
            }
        }
        this.state.needUpdateComponent = true;
        this.setState({
            columnData: aColumnData,
            needUpdateComponent: true
        });
    }

    onRowClick(theRow) {
        if (theRow == null || (typeof theRow) === "undefined" || theRow.idx_in_trips === null || theRow.idx_in_trips.length === 0) {
            return;
        }
        let aNewTrips = this.state.trips;
        let aNewColumnData = this.state.columnData;
        let aBodyStyle = { padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
        if (this.state.trips[parseInt(theRow.idx_in_trips) - 1].singleSelected) {
            aNewTrips[parseInt(theRow.idx_in_trips) - 1].singleSelected = false;
            this.state.trips[parseInt(theRow.idx_in_trips) - 1].singleSelected = false;
            aBodyStyle = { padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
        } else {
            aNewTrips[parseInt(theRow.idx_in_trips) - 1].singleSelected = true;
            this.state.trips[parseInt(theRow.idx_in_trips) - 1].singleSelected = true;
            aBodyStyle = { padding: 8, backgroundColor: "lightblue", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
        }
        aNewColumnData[parseInt(theRow.idx_in_trips) - 1].trip_info = <Card style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={aBodyStyle}
            bordered={false} type="inner" >
            <Row type="flex" justify="space-between" align="middle">
                <Col>
                    <font size="2"><b>{aNewTrips[parseInt(theRow.idx_in_trips) - 1].client_name.toUpperCase()}</b></font><font size="2" style={{ marginLeft: 6 }}>({aNewTrips[parseInt(theRow.idx_in_trips) - 1].trip_direction.toUpperCase()})</font>
                </Col>
                <Col>
                    <font size="2">{aNewTrips[parseInt(theRow.idx_in_trips) - 1].trip_type.toUpperCase()}</font>
                </Col>
            </Row>
            <Row type="flex" justify="start" align="middle">
                <Col>
                    <font size="1"><b>{this.convertMinutesToAmPm(aNewTrips[parseInt(theRow.idx_in_trips) - 1].pu_time)}</b></font>
                </Col>
                <Col style={{ marginLeft: 8 }}>
                    <font size="1"><b>{aNewTrips[parseInt(theRow.idx_in_trips) - 1].pu_addr.toUpperCase()}</b></font>
                </Col>
            </Row>
            <Row type="flex" justify="start" align="middle">
                <Col style={{ marginLeft: 40 }}>
                    <Icon type="arrow-down" />
                </Col>
                <Col style={{ marginLeft: 6 }}>
                    <font size="2">{aNewTrips[parseInt(theRow.idx_in_trips) - 1].segment_id.toUpperCase()}</font>
                </Col>
                <Col style={{ marginLeft: 8 }}>
                    <font size="1"><b>{aNewTrips[parseInt(theRow.idx_in_trips) - 1].oper_id.toUpperCase()}</b></font>
                </Col>
                <Col style={{ marginLeft: 8 }}>
                    <font size="2" style={{ color: "green" }}><b>{aNewTrips[parseInt(theRow.idx_in_trips) - 1].status.toUpperCase()}</b></font>
                </Col>
            </Row>
            <Row type="flex" justify="start" align="middle">
                <Col>
                    <font size="1"><b>{this.convertMinutesToAmPm(aNewTrips[parseInt(theRow.idx_in_trips) - 1].do_time)}</b></font>
                </Col>
                <Col style={{ marginLeft: 8 }}>
                    <font size="1"><b>{aNewTrips[parseInt(theRow.idx_in_trips) - 1].do_addr.toUpperCase()}</b></font>
                </Col>
            </Row>
        </Card>
        this.state.columnData[parseInt(theRow.idx_in_trips) - 1].trip_info = aNewColumnData[parseInt(theRow.idx_in_trips) - 1].trip_info;
        this.state.needUpdateComponent = true;
        this.setState({
            trips: aNewTrips,
            columnData: aNewColumnData,
            needUpdateComponent: true
        });
        // this.setState({ columnData: aNewColumnData });
        this.props.updateTripsSelection(aNewTrips);
    }

    onRowClick_NIU(theRow) {
        if (theRow == null || (typeof theRow) === "undefined" || theRow.idx_in_trips === null || theRow.idx_in_trips.length === 0) {
            return;
        }
        let aNewTrips = this.state.trips;
        let aNewColumnData = this.state.columnData;
        let aBodyStyle = { padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
        if (this.state.trips[parseInt(theRow.idx_in_trips) - 1].selected) {
            aNewTrips[parseInt(theRow.idx_in_trips) - 1].selected = false;
            this.state.trips[parseInt(theRow.idx_in_trips) - 1].selected = false;
            aBodyStyle = { padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
        } else {
            aNewTrips[parseInt(theRow.idx_in_trips) - 1].selected = true;
            this.state.trips[parseInt(theRow.idx_in_trips) - 1].selected = true;
            aBodyStyle = { padding: 8, backgroundColor: "lightblue", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
        }
        aNewColumnData[parseInt(theRow.idx_in_trips) - 1].trip_info = <Card style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={aBodyStyle}
            bordered={false} type="inner" >
            <Row type="flex" justify="space-between" align="middle">
                <Col>
                    <font size="2"><b>{aNewTrips[parseInt(theRow.idx_in_trips) - 1].client_name.toUpperCase()}</b></font><font size="2" style={{ marginLeft: 6 }}>({aNewTrips[parseInt(theRow.idx_in_trips) - 1].trip_direction.toUpperCase()})</font>
                </Col>
                <Col>
                    <font size="2">{aNewTrips[parseInt(theRow.idx_in_trips) - 1].trip_type.toUpperCase()}</font>
                </Col>
            </Row>
            <Row type="flex" justify="start" align="middle">
                <Col>
                    <font size="1"><b>{this.convertMinutesToAmPm(aNewTrips[parseInt(theRow.idx_in_trips) - 1].pu_time)}</b></font>
                </Col>
                <Col style={{ marginLeft: 8 }}>
                    <font size="1"><b>{aNewTrips[parseInt(theRow.idx_in_trips) - 1].pu_addr.toUpperCase()}</b></font>
                </Col>
            </Row>
            <Row type="flex" justify="start" align="middle">
                <Col style={{ marginLeft: 40 }}>
                    <Icon type="arrow-down" />
                </Col>
                <Col style={{ marginLeft: 6 }}>
                    <font size="2">{aNewTrips[parseInt(theRow.idx_in_trips) - 1].segment_id.toUpperCase()}</font>
                </Col>
                <Col style={{ marginLeft: 8 }}>
                    <font size="1"><b>{aNewTrips[parseInt(theRow.idx_in_trips) - 1].oper_id.toUpperCase()}</b></font>
                </Col>
                <Col style={{ marginLeft: 8 }}>
                    <font size="2" style={{ color: "green" }}><b>{aNewTrips[parseInt(theRow.idx_in_trips) - 1].status.toUpperCase()}</b></font>
                </Col>
            </Row>
            <Row type="flex" justify="start" align="middle">
                <Col>
                    <font size="1"><b>{this.convertMinutesToAmPm(aNewTrips[parseInt(theRow.idx_in_trips) - 1].do_time)}</b></font>
                </Col>
                <Col style={{ marginLeft: 8 }}>
                    <font size="1"><b>{aNewTrips[parseInt(theRow.idx_in_trips) - 1].do_addr.toUpperCase()}</b></font>
                </Col>
            </Row>
        </Card>
        this.state.columnData[parseInt(theRow.idx_in_trips) - 1].trip_info = aNewColumnData[parseInt(theRow.idx_in_trips) - 1].trip_info;
        this.state.needUpdateComponent = true;
        this.setState({
            trips: aNewTrips,
            columnData: aNewColumnData,
            needUpdateComponent: true
        });
        // this.setState({ columnData: aNewColumnData });
        this.props.updateTripsSelection(aNewTrips);
    }

    onRowSelect(theRow, theSelected, theSelectedRows, theNativeEvent) {
        if (theRow == null || (typeof theRow) === "undefined" || theRow.idx_in_trips === null || theRow.idx_in_trips.length === 0) {
            return;
        }
        let aNewTrips = this.state.trips;
        let aNewColumnData = this.state.columnData;
        let aBodyStyle = { padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
        if (this.state.trips[parseInt(theRow.idx_in_trips) - 1].selected) {
            aNewTrips[parseInt(theRow.idx_in_trips) - 1].selected = false;
            this.state.trips[parseInt(theRow.idx_in_trips) - 1].selected = false;
            aBodyStyle = { padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
        } else {
            aNewTrips[parseInt(theRow.idx_in_trips) - 1].selected = true;
            this.state.trips[parseInt(theRow.idx_in_trips) - 1].selected = true;
            aBodyStyle = { padding: 8, backgroundColor: "lightblue", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
        }
        this.setState({
            trips: aNewTrips
        });
        this.props.updateTripsSelection(aNewTrips);
    }

    onAllRowsSelect(isSelected, theSelected, theSelectedRows, theNativeEvent) {
        let aNewTrips = this.state.trips;
        if (isSelected) {
            for (var i = 0; i < aNewTrips.length; i++) {
                aNewTrips[i].selected = false;
            }
        }
        outterloop: for (var i = 0; i < this.state.trips.length; i++) {
            if (isSelected) {
                if (this.state.searchTxt !== null && this.state.searchTxt.length !== 0) {
                    /* let aSearchArray = this.state.searchTxt.split(/(\s+)/).filter(function (e) { return e.trim().length > 0; });
                    for (var j = 0; j < aSearchArray.length; j++) {
                        if (aNewTrips[i].client_name.toLowerCase().indexOf(aSearchArray[j].toLowerCase()) >= 0 || aNewTrips[i].pu_addr.toLowerCase().indexOf(aSearchArray[j].toLowerCase()) >= 0 ||
                            aNewTrips[i].do_addr.toLowerCase().indexOf(aSearchArray[j].toLowerCase()) >= 0 || aNewTrips[i].segment_id.toLowerCase().indexOf(aSearchArray[j].toLowerCase()) >= 0 ||
                            aNewTrips[i].trip_type.toLowerCase().indexOf(aSearchArray[j].toLowerCase()) >= 0 || aNewTrips[i].status.toLowerCase().indexOf(aSearchArray[j].toLowerCase()) >= 0) {
                            aNewTrips[i].selected = true;
                            this.state.trips[i].selected = true;
                            continue outterloop;
                        }
                    } */
                    if (aNewTrips[i].client_name.toLowerCase().indexOf(this.state.searchTxt.toLowerCase()) >= 0 || aNewTrips[i].pu_addr.toLowerCase().indexOf(this.state.searchTxt.toLowerCase()) >= 0 ||
                    aNewTrips[i].do_addr.toLowerCase().indexOf(this.state.searchTxt.toLowerCase()) >= 0 || aNewTrips[i].segment_id.toLowerCase().indexOf(this.state.searchTxt.toLowerCase()) >= 0 || 
                    aNewTrips[i].trip_type.toLowerCase().indexOf(this.state.searchTxt.toLowerCase()) >= 0 || aNewTrips[i].status.toLowerCase().indexOf(this.state.searchTxt.toLowerCase()) >= 0 ) {
                            aNewTrips[i].selected = true;
                            this.state.trips[i].selected = true;
                            continue;
                    }
                } else {
                    aNewTrips[i].selected = true;
                    this.state.trips[i].selected = true;
                }
            } else {
                aNewTrips[i].selected = false;
                this.state.trips[i].selected = false;
            }
        }
        this.setState({
            trips: aNewTrips
        });
        this.props.updateTripsSelection(aNewTrips);
    }

    onSelectChange = (theSelectedRowKeys, theSelectedRows) => {
        // this.setState({ selectedRowKeys });
        this.setState({ selectedRowKeys: theSelectedRowKeys, needUpdateComponent: true });
        // this.props.updateRtdTripsTableSelectedRowKeys(theSelectedRowKeys);
        this.state.selectedRowKeys = theSelectedRowKeys;
        this.state.needUpdateComponent = true;
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.needUpdateComponent) {
            this.setState({ needUpdateComponent: false });
            this.state.needUpdateComponent = false;
            return true;
        }
        return false;
    }

    showTotalTripCount() {
        return `Total ${this.state.columnData.length} Trips`;
    }

    onRowClickTest(e, theRecord) {
        e.preventDefault();
        console.log(theRecord);
    }

    onClickFindBest(e) {
        let aIdx = parseInt(e.ref.props.className) - 1;
        console.log(aIdx);
        let socket = openSocket(this.props.GSENodeJsUrl);
        thisContext = this;
        socket.on('finish', function (data) {
            console.log('Caught Event "finish" after calling cmd, data: ' + data);
            // data = "<?xml version=\"1.0\" standalone=\"yes\"?><NewDataSet><Table><TripInfo>T11224152; Pickup ETA: 1251P; Dropoff ETA: 0117P; Impact: On time</TripInfo><Segid>S112</Segid><PuDist>0.000000</PuDist><DoDist>0.000000</DoDist><PUSTP>101</PUSTP><DOSTP>126</DOSTP><PuEtd>1252P</PuEtd><DoEtd>0117P</DoEtd><PUEDGE_START_ADDRESS>42.40915,-71.0377</PUEDGE_START_ADDRESS><PUEDGE_END_ADDRESS>42.410082,-71.0087</PUEDGE_END_ADDRESS><DOEDGE_START_ADDRESS>42.36961,-71.0353</DOEDGE_START_ADDRESS><DOEDGE_END_ADDRESS>42.362636,-71.0639</DOEDGE_END_ADDRESS><Trip_Pu>42.408617,-71.01179</Trip_Pu><Trip_Do>42.371635,-71.03562</Trip_Do><Segment>S112</Segment><PU_after>399</PU_after><DO_after>404</DO_after></Table><Table><TripInfo>T11224152; Pickup ETA: 1255P; Dropoff ETA: 0118P; Impact: On time</TripInfo><Segid>S112</Segid><PuDist>0.000000</PuDist><DoDist>0.000000</DoDist><PUSTP>106</PUSTP><DOSTP>126</DOSTP><PuEtd>1256P</PuEtd><DoEtd>0118P</DoEtd><PUEDGE_START_ADDRESS>42.410082,-71.0087</PUEDGE_START_ADDRESS><PUEDGE_END_ADDRESS>42.400967,-71.02849</PUEDGE_END_ADDRESS><DOEDGE_START_ADDRESS>42.36961,-71.0353</DOEDGE_START_ADDRESS><DOEDGE_END_ADDRESS>42.362636,-71.0639</DOEDGE_END_ADDRESS><Trip_Pu>42.408617,-71.01179</Trip_Pu><Trip_Do>42.371635,-71.03562</Trip_Do><Segment>S112</Segment><PU_after>400</PU_after><DO_after>404</DO_after></Table></NewDataSet>";
            if (data != null && data.length != 0 && data.toLowerCase().indexOf("no routes") < 0) {
                var aXmlData = parser.parseFromString(data, "text/xml");
                var aJsonData = thisContext.xmlToJson(aXmlData);
                if (!thisContext.isEmptyObj(aJsonData) && typeof aJsonData != "undefined" &&
                    !thisContext.isEmptyObj(aJsonData.NewDataSet) && typeof aJsonData.NewDataSet != "undefined" &&
                    typeof aJsonData.NewDataSet.Table != "undefined" && aJsonData.NewDataSet.Table != null && aJsonData.NewDataSet.Table.length != 0) {
                    thisContext.props.onReceiveFindBestResult(aJsonData.NewDataSet.Table, aIdx);
                }
            } else {
                Modal.warning({
                    content: "No route found."
                });
            }
        });
        socket.on('connect_error',
            function (data) {
                console.log(data.message);
            }
        );
        console.log("Calling -f Cmd with: " + this.props.userName + "~" + this.props.selectedDate.replace("-20", "-") + "~" + this.state.trips[aIdx].trip_id + "~" + this.state.trips[aIdx].pu_id + "~" + this.state.trips[aIdx].do_id)
        socket.emit("-f", this.props.userName, this.props.selectedDate.replace("-20", "-"), this.state.trips[aIdx].trip_id, this.state.trips[aIdx].pu_id, this.state.trips[aIdx].do_id);
    }

    isEmptyObj(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop))
                return false;
        }
        return JSON.stringify(obj) === JSON.stringify({});
    }

    onClickRefreshTrips() {
        document.getElementsByClassName("search_trips_input")[0].children[0].value = "";
        this.setState({ searchTxt: "", selectedRowKeys: [] });
        // this.props.updateRtdTripsTableSelectedRowKeys([]);
        this.props.handleRefreshTrips();
    }

    render() {
        /* const columns = [{
            title: <Search
                placeholder="Input Search Text"
                onSearch={value => this.onTxtSearch(value)}
                enterButton
                style={{ width: 268 }}
            />,
            dataIndex: 'trip_info',
            width: 330,
            render: (text, record) => record.trip_info,
        }]; */
        const columns = [{
            title: <div>
                <Search
                    className="search_trips_input"
                    placeholder="Input Search Text"
                    onSearch={value => this.onTxtSearch(value)}
                    enterButton
                    style={{ width: 225 }} />
                <Button type="primary" shape="circle" icon="reload" size="default" style={{ marginLeft: 10 }} onClick={this.onClickRefreshTrips} />
            </div>,
            dataIndex: 'trip_info',
            width: 330,
            render: (text, record) => record.trip_info,
        }];

        // rowSelection object indicates the need for row selection
        // const { selectedRowKeys } = this.state;
        const rowSelection = {
            hideDefaultSelections: false,
            columnWidth: 20,
            fixed: false,
            selections: false,
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                this.onSelectChange(selectedRowKeys, selectedRows);
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
            onSelect: (record, selected, selectedRows, nativeEvent) => {
                this.onRowSelect(record, selected, selectedRows, nativeEvent);
            },
            onSelectAll: (record, selected, selectedRows, nativeEvent) => {
                this.onAllRowsSelect(record, selected, selectedRows, nativeEvent);
            }
        };
        return (
            <div>
                {/* <Row type="flex" justify="space-between" align="middle" style={{ marginLeft: 6, marginBottom: 6 }}>
                    <Col>
                        <Search
                            placeholder="Input Search Text"
                            onSearch={value => this.onTxtSearch(value)}
                            enterButton
                            style={{ width: 188 }}
                        />
                    </Col>
                    <Col>
                        <Checkbox onChange={this.onCheckBoxChange}>Select All</Checkbox>
                    </Col>
                </Row> 
        */}
                <Table rowSelection={rowSelection} columns={columns} dataSource={this.state.columnData} pagination={{ pageSize: 66, /*showSizeChanger: true, size: "small", total: this.state.columnData.length, showTotal: (total, range) => <p><font size="1">{range[0]}-{range[1]} of {total}</font></p>*/ }} scroll={{ y: window.innerHeight - 440 }} showHeader={true} size="small" style={{ backgroundColor: "rgba(255, 255, 255, 0)" }}
                    onRow={(record) => {
                        return {
                            // onClick: () => { this.onRowClick(record) }
                            // onClick: () => {this.onRowClickTest(record)},
                            onContextMenu: (e) => { this.onRowClickTest(e, record) }
                            // onContextMenu: (e) => e.preventDefault()
                        };
                    }} >
                </Table>
                <ContextMenu id={id_enable_FindBest}>
                    <Item onClick={this.onClickFindBest}>Find Best</Item>
                    {/*<Separator />
                    <Item >Cancel</Item>*/}
                </ContextMenu>
                <ContextMenu id={id_disable_FindBest}>
                    <Item disabled>Find Best</Item>
                    {/*<Separator />
                    <Item >Cancel</Item>*/}
                </ContextMenu>
                {/* <List style={{overflowY: "auto"}}
                    itemLayout="vertical"
                    dataSource={bTestData}
                    renderItem={item => (
                        <List.Item>
                            <Card style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}
                                bordered={false} type="inner" >
                                <Row type="flex" justify="space-between" align="middle">
                                    <Col>
                                        <font size="2"><b>MOORE, UNIQUE</b></font><font size="2" style={{ marginLeft: 6 }}>(OUT)</font>
                                    </Col>
                                    <Col>
                                        <font size="2">MEDICAID-BOSTON</font>
                                    </Col>
                                </Row>
                                <Row type="flex" justify="start" align="middle">
                                    <Col>
                                        <font size="1"><b>0900AM</b></font>
                                    </Col>
                                    <Col style={{ marginLeft: 8 }}>
                                        <font size="1"><b>66 ROCKLAND ST, ROXBURY</b></font>
                                    </Col>
                                </Row>
                                <Row type="flex" justify="start" align="middle">
                                    <Col style={{ marginLeft: 40 }}>
                                        <Icon type="arrow-down" />
                                    </Col>
                                    <Col style={{ marginLeft: 6 }}>
                                        <font size="2">S118</font>
                                    </Col>
                                    <Col style={{ marginLeft: 8 }}>
                                        <font size="1"><b>ATLWL</b></font>
                                    </Col>
                                    <Col style={{ marginLeft: 8 }}>
                                        <font size="2" style={{ color: "green" }}><b>CONFIRMED</b></font>
                                    </Col>
                                </Row>
                                <Row type="flex" justify="start" align="middle">
                                    <Col>
                                        <font size="1"><b>1200PM</b></font>
                                    </Col>
                                    <Col style={{ marginLeft: 8 }}>
                                        <font size="1"><b>780 AMERICAN LEGION HWY, BOSTON</b></font>
                                    </Col>
                                </Row>
                            </Card>
                        </List.Item>
                    )}
                /> */}
                {/* <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)", width: 330, padding: 0, overflowY: "auto" }} bodyStyle={{ padding: 6}}>
                    <Card style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}
                        bordered={false} type="inner" >
                        <Row type="flex" justify="space-between" align="middle">
                            <Col>
                                <font size="2"><b>MOORE, UNIQUE</b></font><font size="2" style={{ marginLeft: 6 }}>(OUT)</font>
                            </Col>
                            <Col>
                                <font size="2">MEDICAID-BOSTON</font>
                            </Col>
                        </Row>
                        <Row type="flex" justify="start" align="middle">
                            <Col>
                                <font size="1"><b>0900AM</b></font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="1"><b>66 ROCKLAND ST, ROXBURY</b></font>
                            </Col>
                        </Row>
                        <Row type="flex" justify="start" align="middle">
                            <Col style={{ marginLeft: 40 }}>
                                <Icon type="arrow-down" />
                            </Col>
                            <Col style={{ marginLeft: 6 }}>
                                <font size="2">S118</font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="1"><b>ATLWL</b></font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="2" style={{ color: "green" }}><b>CONFIRMED</b></font>
                            </Col>
                        </Row>
                        <Row type="flex" justify="start" align="middle">
                            <Col>
                                <font size="1"><b>1200PM</b></font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="1"><b>780 AMERICAN LEGION HWY, BOSTON</b></font>
                            </Col>
                        </Row>
                    </Card>
                    <Card style={{ backgroundColor: "rgba(255, 255, 255,0)", paddingTop: 6 }} bodyStyle={{ padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}
                        bordered={false} type="inner" >
                        <Row type="flex" justify="space-between" align="middle">
                            <Col>
                                <font size="2"><b>MOORE, UNIQUE</b></font><font size="2" style={{ marginLeft: 6 }}>(OUT)</font>
                            </Col>
                            <Col>
                                <font size="2">MEDICAID-BOSTON</font>
                            </Col>
                        </Row>
                        <Row type="flex" justify="start" align="middle">
                            <Col>
                                <font size="1"><b>0900AM</b></font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="1"><b>66 ROCKLAND ST, ROXBURY</b></font>
                            </Col>
                        </Row>
                        <Row type="flex" justify="start" align="middle">
                            <Col style={{ marginLeft: 40 }}>
                                <Icon type="arrow-down" />
                            </Col>
                            <Col style={{ marginLeft: 6 }}>
                                <font size="2">S118</font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="1"><b>ATLWL</b></font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="2" style={{ color: "green" }}><b>CONFIRMED</b></font>
                            </Col>
                        </Row>
                        <Row type="flex" justify="start" align="middle">
                            <Col>
                                <font size="1"><b>1200PM</b></font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="1"><b>780 AMERICAN LEGION HWY, BOSTON</b></font>
                            </Col>
                        </Row>
                    </Card>
                    {aTestData}
                </Card> */}
            </div>
        );
    }

    convertMinutesToAmPm(theMins) {
        let aIsAm = true;
        if (theMins >= 12 * 60) {
            aIsAm = false;
        }
        let aHr = 0, aMin = 0;
        let aHrStr = "", aMinStr = "";
        if (aIsAm) {
            if (aIsAm === 0) {
                return "0000A";
            }
            aHr = Math.floor(theMins / 60);
            aMin = theMins % 60;
            if (aHr < 10) {
                aHrStr = "0" + aHr.toString();
            } else {
                aHrStr = aHr.toString();
            }
            if (aMin < 10) {
                aMinStr = "0" + aMin.toString();
            } else {
                aMinStr = aMin.toString();
            }
            return aHrStr + aMinStr + "A";
        } else {
            if (theMins === 12 * 60) {
                return "1200P";
            }
            aHr = Math.floor((theMins - 12 * 60) / 60);
            aMin = (theMins - 12 * 60) % 60;
            if (aHr < 10) {
                if (aHr === 0) {
                    aHrStr = "12";
                } else {
                    aHrStr = "0" + aHr.toString();
                }
            } else {
                aHrStr = aHr.toString();
            }
            if (aMin < 10) {
                aMinStr = "0" + aMin.toString();
            } else {
                aMinStr = aMin.toString();
            }
            return aHrStr + aMinStr + "P";
        }
    }

    // Changes XML to JSON
    xmlToJson(xml) {
        // Create the return object
        let obj = {};

        if (xml.nodeType === 1) { // element
            // do attributes
            if (xml.attributes.length > 0) {
                obj['@attributes'] = {};
                for (let j = 0; j < xml.attributes.length; j += 1) {
                    const attribute = xml.attributes.item(j);
                    obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
                }
            }
        } else if (xml.nodeType === 3) { // text
            obj = xml.nodeValue;
        }

        // do children
        // If just one text node inside
        if (xml.hasChildNodes() && xml.childNodes.length === 1 && xml.childNodes[0].nodeType === 3) {
            obj = xml.childNodes[0].nodeValue;
        } else if (xml.hasChildNodes()) {
            for (let i = 0; i < xml.childNodes.length; i += 1) {
                const item = xml.childNodes.item(i);
                const nodeName = item.nodeName;
                if (typeof (obj[nodeName]) === 'undefined') {
                    obj[nodeName] = this.xmlToJson(item);
                } else {
                    if (typeof (obj[nodeName].push) === 'undefined') {
                        const old = obj[nodeName];
                        obj[nodeName] = [];
                        obj[nodeName].push(old);
                    }
                    obj[nodeName].push(this.xmlToJson(item));
                }
            }
        }
        return obj;
    }
}

export default RtdTripsTable;



// WEBPACK FOOTER //
// ./src/Componets/RtdTripsTable.js